import React, { Component } from 'react';


class CommentsModal extends Component {
    // Comments


    ChangeDocComment = (value) => {
        const { RefreshCommentsModel, DocCommentsModel } = this.props
        DocCommentsModel.DocComment = value
        RefreshCommentsModel(DocCommentsModel);
    }

    ChangeCommentLine = (value) => {
        const { RefreshCommentsModel, DocCommentsModel } = this.props
        DocCommentsModel.CommentLine = value
        RefreshCommentsModel(DocCommentsModel);
    }

    SaveCommentsInOrderModel = () => {
        const { newOrderModel, showAlert, DocCommentsModel, CommentLineIndex, RefreshOrder, CleanDocCommentsActions, EnableCommentsModal } = this.props
        newOrderModel.Items[CommentLineIndex].U_FMB_LineComment = DocCommentsModel.CommentLine;
        newOrderModel.Comments = DocCommentsModel.DocComment;
        RefreshOrder(newOrderModel);
        showAlert({ type: "success", message: `Comentarios guardados exitosamente` });
        CleanDocCommentsActions();
        EnableCommentsModal();
    }

    CloseModal = () => {
        const {CleanDocCommentsActions, EnableCommentsModal} = this.props
        CleanDocCommentsActions();
        EnableCommentsModal(); 
    }

    render() {
        const { DocCommentsModel } = this.props;
        
        return (
            <>
                <div className="modal custom fade" id="commentsModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="commentsModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ boxShadow: "1px 1px 5px rgb(0 0 0 / 30%)" }}>
                            <div className="modal-header">
                                {/* <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> */}
                            </div>

                            <div className="modal-body" style={{ minHeight: "130px" }}>
                                <section>
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item waves-effect waves-light">
                                            <h5 className="nav-link active" id="itemComment-tab" data-toggle="tab" href="#itemComment" role="tab" aria-controls="comments" aria-selected="false"><strong>Artículo: {DocCommentsModel && DocCommentsModel.ItemCode}</strong></h5>
                                        </li>
                                        <li className="nav-item waves-effect waves-light">
                                            <h5 className="nav-link" id="generalComment-tab" data-toggle="tab" href="#generalComment" role="tab" aria-controls="comments" aria-selected="false" >Venta general</h5>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="myTabContent" >
                                        {/* -------------------------------------GENERALES--------------------------------------------------------- */}
                                        <div className="tab-pane fade active show" id="itemComment" role="tabpanel" aria-labelledby="general-tab">
                                            <form>
                                                <div className="form-group mt-4">
                                                    {/* <label for="exampleFormControlTextarea1">Comentario:</label> */}
                                                    <textarea
                                                        className="form-control"
                                                        id="bodyMail"
                                                        rows="3"
                                                        placeholder="Comentario de la linea"
                                                        value={DocCommentsModel ? DocCommentsModel.CommentLine : ''}
                                                        onChange={(event) => this.ChangeCommentLine(event.target.value)}
                                                        style={{ minHeight: "180px" }}
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                        {/* -------------------------------------GENERALES--------------------------------------------------------- */}
                                        <div className="tab-pane fade" id="generalComment" role="tabpanel" aria-labelledby="ventas-tab">
                                            <form>
                                                <div className="form-group mt-4">
                                                    {/* <label for="exampleFormControlTextarea1">Comentario:</label> */}
                                                    <textarea
                                                        className="form-control"
                                                        id="bodyMail"
                                                        rows="3"
                                                        placeholder="Comentario del documento"
                                                        style={{ minHeight: "180px" }}
                                                        value={DocCommentsModel ? DocCommentsModel.DocComment : ''}
                                                        onChange={(event) => this.ChangeDocComment(event.target.value)}
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </section>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => this.CloseModal()}>Cancelar</button>
                                <button type="button" data-dismiss="modal"  onClick={()=> this.SaveCommentsInOrderModel()} className="btn btn-primary" >Guardar</button>
                                

                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default CommentsModal